// Redux slice for notifications
const SET_NOTIFICATIONS = 'notifications/SET_NOTIFICATIONS'
const APPEND_NOTIFICATIONS = 'notifications/APPEND_NOTIFICATIONS'
const UPDATE_NOTIFICATION = 'notifications/UPDATE_NOTIFICATION'
const REMOVE_NOTIFICATION = 'notifications/REMOVE_NOTIFICATION'
const SET_PAGINATION = 'notifications/SET_PAGINATION'
const MARK_ALL_AS_READ = 'notifications/MARK_ALL_AS_READ'
const DELETE_ALL_NOTIFICATIONS = 'notifications/DELETE_ALL_NOTIFICATIONS'
const SET_UNREAD_COUNT = 'notifications/SET_UNREAD_COUNT'
export const FETCH_UNREAD_COUNT = 'notifications/FETCH_UNREAD_COUNT'

export function setNotifications(payload) {
  return { type: SET_NOTIFICATIONS, payload }
}

export function appendNotifications(payload) {
  return { type: APPEND_NOTIFICATIONS, payload }
}

export function updateNotification(id, partial) {
  return { type: UPDATE_NOTIFICATION, payload: { id, partial } }
}

export function removeNotification(id) {
  return { type: REMOVE_NOTIFICATION, payload: id }
}

export function setPagination(meta) {
  return { type: SET_PAGINATION, payload: meta }
}

export function markAllAsRead() {
  return { type: MARK_ALL_AS_READ }
}

export function deleteAllNotifications() {
  return { type: DELETE_ALL_NOTIFICATIONS }
}

export function setUnreadCount(count) {
  return { type: SET_UNREAD_COUNT, payload: Number(count || 0) }
}

export function fetchUnreadCount(force = false) {
  return { type: FETCH_UNREAD_COUNT, payload: { force: Boolean(force) } }
}

const initialState = {
  items: [],
  totalElements: 0,
  pageSize: 50,
  currentPage: 0,
  hasNext: false,
  unreadCount: 0,
}

export default function notifications(state = initialState, action = {}) {
  switch (action.type) {
    case SET_NOTIFICATIONS:
      return {
        ...state,
        items: action.payload.items || [],
        totalElements: Number(action.payload.totalElements || 0),
        pageSize: Number(action.payload.pageSize || state.pageSize),
        currentPage: Number(action.payload.currentPage || 0),
        hasNext: Boolean(action.payload.hasNext),
      }

    case APPEND_NOTIFICATIONS:
      return {
        ...state,
        items: [...state.items, ...(action.payload.items || [])],
        totalElements: Number(action.payload.totalElements || state.totalElements),
        currentPage: Number(action.payload.currentPage || state.currentPage),
        hasNext: Boolean(action.payload.hasNext),
      }

    case UPDATE_NOTIFICATION:
      return {
        ...state,
        items: state.items.map(n => n.id === action.payload.id ? { ...n, ...action.payload.partial } : n),
      }

    case REMOVE_NOTIFICATION:
      return {
        ...state,
        items: state.items.filter(n => n.id !== action.payload),
        totalElements: Math.max(0, state.totalElements - 1),
      }

    case SET_PAGINATION:
      return {
        ...state,
        totalElements: Number(action.payload.totalElements || state.totalElements),
        hasNext: Boolean(action.payload.hasNext),
        currentPage: Number(action.payload.currentPage || state.currentPage),
      }

    case MARK_ALL_AS_READ:
      return {
        ...state,
        items: state.items.map(n => ({ ...n, read: true })),
        unreadCount: 0,
      }

    case DELETE_ALL_NOTIFICATIONS:
      return {
        ...state,
        items: [],
        totalElements: 0,
        hasNext: false,
        currentPage: 0,
        unreadCount: 0,
      }

    case SET_UNREAD_COUNT:
      return {
        ...state,
        unreadCount: Number(action.payload || 0),
      }

    default:
      return state
  }
}

export const selectors = {
  all: state => (state.notifications && state.notifications.items) || [],
  meta: state => state.notifications || {},
  unreadCount: state => (state.notifications && Number(state.notifications.unreadCount)) || 0,
}



// WEBPACK FOOTER //
// ./src/redux/notifications.js